<template>
    <div>
        <form v-if="auth.loginScreen === 'login'" @submit.prevent="login()">
            <div class="row">
                <div class="col-12">
                    <h6>Login</h6>
                    <div class="form-group">
                        <div class="input-group">
                            <input id="email" v-model="model.username" type="email" class="form-input" required/>
                            <label class="input-label" for="email">
                                <span class="label-span">{{ $t('auth.email')}}</span>
                            </label>
                        </div>
                        <p v-if="!model.username" class="input-error">{{ $t('auth.emailIsRequired')}}</p>
                    </div>
                </div>

                <div class="col-12">
                    <div class="form-group">
                        <div class="input-group">
                            <input id="password" v-model="model.password" type="password" class="form-input" minlength="6" maxlength="13" required/>
                            <label class="input-label" for="password">
                                <span class="label-span">{{ $t('auth.password')}}</span>
                            </label>
                        </div>
                    </div>

                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <auth-base-button :title="$t('auth.login')" :loading="auth.authLoading"></auth-base-button>
                </div>
            </div>
        </form>
        <form v-if="auth.loginScreen === 'otp'" @submit.prevent="changePassword()">
            <div class="row">
                <div class="col-12">
                    <h6><span style="cursor: pointer; font-size: 20px;" @click="$store.commit('auth/updateLoginScreen','login')"><strong><b-icon-arrow-left/></strong></span> Change Password</h6>
                    <div class="form-group">
                        <div class="input-group">
                            <input id="oldPassword" autocomplete="new-password" v-model="model.oldPassword" type="password" class="form-input" minlength="6" maxlength="6" required/>
                            <label class="input-label" for="oldPassword">
                                <span class="label-span">Old Password</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <div class="input-group">
                            <input id="newPassword" autocomplete="new-password" v-model="model.password" type="password" class="form-input" minlength="6" maxlength="6" required/>
                            <label class="input-label" for="newPassword">
                                <span class="label-span">New Password</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <div class="input-group">
                            <input id="passwordConfirmation" v-model="model.passwordConfirmation" type="password" class="form-input" minlength="6" maxlength="6" required/>
                            <label class="input-label" for="passwordConfirmation">
                                <span class="label-span">Password Confirmation</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <auth-base-button :title="$t('auth.login')" :loading="auth.authLoading"></auth-base-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import AuthBaseButton from "../button/AuthBaseButton";
    export default {
        name: "LogonForm",
        components: {
            AuthBaseButton
        },
        data() {
            return {
                model: {
                    username: "",
                    password: "",
                    passwordConfirmation: "",
                    oldPassword: "",
                    ipAddress: "10.0.0.11",
                    source: "MOBILE",
                    longitude: "6.2222888",
                    latitude: "3.98000",
                    deviceId: "233333098988",
                    devicePlatform: "Android",
                    deviceName: "Infinix",
                    appVersion: "10.0"
                },
            }
        },
        methods: {

            clicked(){
                this.$swal({
                    title: 'Custom animation with Animate.css',
                    showClass: {
                        popup: 'animated slideInLeft faster display-6'
                    },
                    hideClass: {
                        popup: 'animated slideOutRight faster display-6'
                    },
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!'
                })
            },
            async login() {
                localStorage.clear()
                await this.$store.dispatch("auth/logon", this.model, { root: false })
                this.model.password = ''
                this.model.passwordConfirmation = ''
                this.model.oldPassword = ''
            },

            async changePassword() {
                localStorage.clear()
                await this.$store.dispatch("auth/changePassword", this.model, { root: false })
                this.$store.commit('auth/updateLoginScreen','login')
            },

            async passwordReset1() {
                await this.$store.dispatch("auth/initiateResetPassword", this.model, { root: false })
            },

            async passwordReset2() {
                await this.$store.dispatch("auth/verifyToken", this.model, { root: false })
            },

            async passwordReset3() {
                await this.$store.dispatch("auth/completeResetPassword", this.model, { root: false })
            },

        },
        computed:{
            ...mapState([
                'company',
                'document',
                'auth',
                'auth',
                'officer',
            ]),

        },

        watch: {
            'auth': function() {
                console.log('Hello World!')
            }
        },
        mounted() {
            this.$store.commit('auth/updateLoginScreen','login')
        },
    }
</script>

<style scoped>

</style>
